export class Door {
    id: string;
    eventDate: Date;
    type: boolean;
    signature: string;
    latitude: string;
    longitude: string;
}
